const NAME = "TRAINING";

export default NAME;
